module.exports = __webpack_public_path__ + "static/img/analysis4.c7f0fcb9.png";